export const BotUserId = '1010'
export const BotUserId2 = '0101'
